import React from 'react'
import styles from './hamburgerMenu.module.scss';
import { Link, useLocation } from 'react-router-dom';
import { Badge } from '@mui/material';

export const LinkC = ({ icon, to, name, }) => {


    return (
        <Link
            to={to}
            key={name}
            className={`${styles.link}`}
        >
            <img src={icon} className={styles.icons} />
            {
                name === 'Marketplace' ?
                    <Badge badgeContent='Nuevo' color='success' >
                        {name}
                    </Badge>
                    : name
            }

        </Link>
    )
}
